<template>
    <v-row>
        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Colegios"
                        multiple
                        prepend-icon="fas fa-chalkboard-teacher">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Universidades"
                        multiple
                        prepend-icon="fas fa-graduation-cap">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Clinicas y hospitales"
                        multiple
                        prepend-icon="fas fa-hospital">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Centros comerciales"
                        multiple
                        prepend-icon="fas fa-shopping-bag">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Iglesias"
                        multiple
                        prepend-icon="fas fa-church">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Supermercados"
                        multiple
                        prepend-icon="fas fa-shopping-cart">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Restaurantes / Cafeterías"
                        multiple
                        prepend-icon="fas fa-utensils">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Vías principales"
                        multiple
                        prepend-icon="fas fa-road">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Transporte público (Metro / Bus)"
                        multiple
                        prepend-icon="fas fa-bus">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Zona industrial"
                        multiple
                        prepend-icon="fas fa-industry">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Areopuertos"
                        multiple
                        prepend-icon="fas fa-plane">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-combobox chips
                        deletable-chips
                        label="Otros"
                        multiple
                        prepend-icon="add">
            </v-combobox>
        </v-col>

        <v-col cols="12">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="abadPrimary" @click="submit" dark>Continuar</v-btn>
            </v-card-actions>
        </v-col>
    </v-row>
</template>

<script>
export default {
  methods: {
    submit () {
      this.$emit('updateStateForm', true)
    }
  }
}
</script>
